module.exports = __webpack_public_path__ + "img/apple.891a55e2.png";